module.exports = __webpack_public_path__ + "img/4.7e4828f4.webp";